export default {"src":"/newStatic/_next/static/media/coinGeckoLogoWhite.f0bd67d2.svg","height":276,"width":276};